import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "alert-icon fal fa-info-circle fa-lg" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["id"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_8 = { colspan: "3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args))),
      style: {"cursor":"pointer"}
    }, [
      _createElementVNode("td", null, [
        _createElementVNode("input", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggleSelected')), ["stop"])),
          class: "form-check-input",
          type: "checkbox",
          checked: _ctx.selected
        }, null, 8, _hoisted_1)
      ]),
      _hoisted_2,
      _createElementVNode("td", null, _toDisplayString(_ctx.subject), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.elapsedTime), 1),
      _createElementVNode("td", {
        class: _normalizeClass([{ 'text-primary': !_ctx.read },{ 'text-white': _ctx.read }])
      }, _hoisted_4, 2)
    ]),
    _createElementVNode("tr", {
      id: _ctx.id,
      style: {"display":"none"}
    }, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.message), 1)
    ], 8, _hoisted_5)
  ], 64))
}